import React, { createContext, useContext, useEffect, useState } from "react";

const DataContext = createContext({ caseStudies: [], blogs: [] });

export function DataProvider({ children }) {
  const [caseStudies, setCaseStudies] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    Promise.all([
      fetch("/data/caseStudies.json").then((r) => r.json()),
      fetch("/data/blogs.json").then((r) => r.json()),
    ]).then(([cs, bl]) => {
      setCaseStudies(cs);
      setBlogs(bl);
      setLoading(false);
    });
  }, []);

  return (
    <DataContext.Provider value={{ caseStudies, blogs, loading }}>
      {children}
    </DataContext.Provider>
  );
}

export function useData() {
  return useContext(DataContext);
}